import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-field-mapping-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './field-mapping-dialog.component.html',
  styleUrls: ['./field-mapping-dialog.component.css']
})
export class FieldMappingDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<FieldMappingDialogComponent>
  ) { }


  cancel() {
    this.dialogRef.close(false);
  }

  continue() {
    this.dialogRef.close(true);
  }
}
